import { deviceDetection } from '@marvelapp/core';
export function removeScreenPermissionIfOnMobile(permissions) {
    return Object.assign(Object.assign({}, permissions), { screen: permissions.screen && !deviceDetection.isMobile });
}
export function parseUrl(url) {
    const urlObj = new URL(url);
    const domain = urlObj.hostname.split('.').slice(-2).join('.');
    return Object.assign(urlObj, { domainWithoutSubdomains: domain });
}
